import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();

  // Subtle scroll-reveal for page sections (skippable via reduced motion)
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const sections = Array.from(document.querySelectorAll("main section"));
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          el.classList.remove("reveal-init");
          el.classList.add("reveal-in");
          observer.unobserve(el);
        });
      },
      { threshold: 0.06, rootMargin: "0px 0px -48px 0px" }
    );

    const frame = requestAnimationFrame(() => {
      sections.forEach((el, i) => {
        const inView = el.getBoundingClientRect().top < window.innerHeight * 0.95;
        el.style.transitionDelay = inView && i < 3 ? `${i * 90}ms` : "0ms";
        el.classList.add("reveal-init");
        if (inView) {
          requestAnimationFrame(() => {
            el.classList.remove("reveal-init");
            el.classList.add("reveal-in");
          });
        } else {
          observer.observe(el);
        }
      });
    });

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      sections.forEach((el) => {
        el.classList.remove("reveal-init", "reveal-in");
        el.style.transitionDelay = "";
      });
    };
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#2B2623] font-body">
      <Navbar />
      <main className="pt-24">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
